import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prompts');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";


@Component({
    selector: 'wiz-page-prompts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prompts/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.prompt-primary-button,
.prompt-secondary-button,
.prompt-save-button,
.prompt-publish-button,
.prompt-delete-button {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 0.625rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}

.prompt-primary-button,
.prompt-save-button {
  border: 1px solid #4f46e5;
  background: #4f46e5;
  color: #fff;
}
.prompt-primary-button:hover:not(:disabled),
.prompt-save-button:hover:not(:disabled) {
  background: #4338ca;
}

.prompt-secondary-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}
.prompt-secondary-button:hover:not(:disabled) {
  background: #f8fafc;
}

.prompt-publish-button {
  border: 1px solid #059669;
  background: #ecfdf5;
  color: #047857;
}
.prompt-publish-button:hover:not(:disabled) {
  background: #d1fae5;
}

.prompt-delete-button {
  border: 1px solid #fecaca;
  background: #fff;
  color: #dc2626;
}
.prompt-delete-button:hover:not(:disabled) {
  border-color: #fca5a5;
  background: #fef2f2;
  color: #b91c1c;
}

.prompt-primary-button:disabled,
.prompt-secondary-button:disabled,
.prompt-save-button:disabled,
.prompt-publish-button:disabled,
.prompt-delete-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.prompt-summary-card {
  display: flex;
  min-height: 6rem;
  align-items: center;
  gap: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 1rem 1.125rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.prompt-summary-icon {
  display: inline-flex;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.875rem;
}

.prompt-catalog-layout {
  display: grid;
  align-items: start;
  gap: 1.25rem;
}

.prompt-theme-panel {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.prompt-search-input {
  width: 100%;
  min-height: 2.625rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.625rem 0.75rem 0.625rem 2.25rem;
  font-size: 0.75rem;
  color: #0f172a;
  outline: none;
}
.prompt-search-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.prompt-search-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.prompt-search-select {
  min-width: 0;
  min-height: 2.375rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #fff;
  padding: 0.5rem 0.625rem;
  font-size: 0.6875rem;
  color: #475569;
  outline: none;
}
.prompt-search-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.prompt-search-select-wide {
  grid-column: 1/-1;
}

.prompt-theme-list {
  max-height: 38rem;
  overflow-y: auto;
  padding: 0.5rem;
}

.prompt-draft-item {
  display: flex;
  width: 100%;
  align-items: stretch;
  margin-bottom: 0.375rem;
  overflow: hidden;
  border: 1px dashed #a78bfa;
  border-radius: 0.75rem;
  background: #faf5ff;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}
.prompt-draft-item:hover {
  border-color: #8b5cf6;
  background: #f5f3ff;
}
.prompt-draft-item.is-selected {
  border-style: solid;
  border-color: #8b5cf6;
  background: #f5f3ff;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
}

.prompt-draft-open {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
}

.prompt-draft-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #fff;
  color: #7c3aed;
  box-shadow: 0 1px 2px rgba(76, 29, 149, 0.1);
}

.prompt-draft-copy {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-align: left;
}

.prompt-draft-title,
.prompt-draft-meta {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-draft-title {
  color: #2e1065;
  font-size: 0.8125rem;
  font-weight: 800;
  line-height: 1.25rem;
}

.prompt-draft-meta {
  margin-top: 0.25rem;
  color: #7c3aed;
  font-size: 0.6875rem;
  line-height: 1rem;
}

.prompt-draft-discard {
  width: 2.5rem;
  flex: 0 0 auto;
  border-left: 1px solid rgba(167, 139, 250, 0.35);
  color: #8b5cf6;
}
.prompt-draft-discard:hover, .prompt-draft-discard:focus-visible {
  background: #ede9fe;
  color: #6d28d9;
  outline: none;
}

.prompt-theme-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.75rem;
  padding: 0.75rem;
  color: #475569;
  transition: background-color 140ms ease, border-color 140ms ease;
}
.prompt-theme-item:hover {
  background: #f8fafc;
}
.prompt-theme-item.is-selected {
  border-color: #c7d2fe;
  background: #eef2ff;
}

.prompt-theme-item-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #f1f5f9;
  color: #64748b;
}
.is-selected .prompt-theme-item-icon {
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.prompt-status-badge {
  display: inline-flex;
  min-height: 1.625rem;
  align-items: center;
  gap: 0.375rem;
  border-radius: 9999px;
  padding: 0.25rem 0.625rem;
  font-size: 0.625rem;
  font-weight: 800;
}

.prompt-version-chip {
  display: inline-flex;
  min-height: 2rem;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #fff;
  padding: 0.35rem 0.7rem;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
}
.prompt-version-chip:hover, .prompt-version-chip.is-selected {
  border-color: #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
}

.prompt-editor-grid {
  display: grid;
}

.prompt-field-label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
}

.prompt-field-help {
  display: block;
  margin-top: 0.4rem;
  font-size: 0.6875rem;
  line-height: 1.25rem;
  color: #94a3b8;
}

.prompt-input,
.prompt-select,
.prompt-textarea,
.prompt-code-textarea,
.prompt-rule-textarea {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  color: #0f172a;
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.prompt-input:focus,
.prompt-select:focus,
.prompt-textarea:focus,
.prompt-code-textarea:focus,
.prompt-rule-textarea:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.prompt-input:disabled,
.prompt-select:disabled,
.prompt-textarea:disabled,
.prompt-code-textarea:disabled,
.prompt-rule-textarea:disabled {
  cursor: default;
  background: #f8fafc;
  color: #64748b;
}

.prompt-input,
.prompt-select {
  min-height: 2.75rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.8125rem;
}

.prompt-textarea,
.prompt-rule-textarea {
  resize: vertical;
  padding: 0.7rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1.45rem;
}

.prompt-code-textarea {
  resize: vertical;
  padding: 0.85rem;
  background: #f8fafc;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  line-height: 1.45rem;
}
.prompt-code-textarea.is-negative {
  border-color: #fed7aa;
  background: #fffaf5;
}
.prompt-code-textarea.is-negative:focus {
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.prompt-rule-textarea {
  min-height: 4.25rem;
  background: #fff;
}

.prompt-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.35rem;
  border-radius: 0.875rem;
  background: #f1f5f9;
  padding: 0.3rem;
}

.prompt-media-tab {
  display: inline-flex;
  min-height: 2.65rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid transparent;
  border-radius: 0.65rem;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
}
.prompt-media-tab:hover {
  color: #4338ca;
}
.prompt-media-tab.is-selected {
  border-color: #e0e7ff;
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.prompt-rules-details {
  border-top: 1px solid #e2e8f0;
  padding-top: 1.25rem;
}
.prompt-rules-details summary {
  display: flex;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: #0f172a;
  font-size: 0.8125rem;
}
.prompt-rules-details summary::-webkit-details-marker {
  display: none;
}
.prompt-rules-details[open] summary > i {
  transform: rotate(180deg);
}
.prompt-rules-details summary > i {
  transition: transform 160ms ease;
}

.prompt-history-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  text-align: left;
}
.prompt-history-row:hover, .prompt-history-row.is-selected {
  background: #f8fafc;
}

.prompt-history-version {
  display: inline-flex;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  background: #f1f5f9;
  font-size: 0.6875rem;
  font-weight: 800;
  color: #475569;
}
.is-selected .prompt-history-version {
  background: #eef2ff;
  color: #4338ca;
}

@media (min-width: 1024px) {
  .prompt-catalog-layout {
    grid-template-columns: 18rem minmax(0, 1fr);
  }
  .prompt-theme-panel {
    position: sticky;
    top: 1.25rem;
  }
}
@media (min-width: 1280px) {
  .prompt-editor-grid {
    grid-template-columns: minmax(0, 1fr) 23rem;
  }
}
@media (max-width: 639px) {
  .prompt-primary-button,
  .prompt-secondary-button,
  .prompt-delete-button {
    min-height: 2.5rem;
    padding-inline: 0.75rem;
  }
  .prompt-theme-list {
    display: flex;
    max-height: none;
    gap: 0.5rem;
    overflow-x: auto;
  }
  .prompt-theme-item {
    min-width: 15rem;
  }
  .prompt-draft-item {
    min-width: 15rem;
  }
  .prompt-media-tab {
    min-height: 2.5rem;
  }
}`],
})
export class PagePromptsComponent implements OnInit {
    public loading: boolean = true;
    public saving: boolean = false;
    public publishing: boolean = false;
    public deleting: boolean = false;
    public errorMessage: string = '';
    public sets: any[] = [];
    public summary: any = { themes: 0, active: 0, versions: 0, results: 0 };
    public canManage: boolean = false;
    public selectedKey: string = '';
    public selectedVersion: number = 0;
    public activeMedia: 'image' | 'audio' | 'video' = 'image';
    public searchText: string = '';
    public searchStatus: string = '';
    public searchMediaType: string = '';
    public searchModel: string = '';
    public isNew: boolean = false;
    public cloneSource: any = null;
    public pendingDraft: any = null;
    public form: any = this.emptyForm();
    public referenceContext: any = null;
    public referenceContextApplied: boolean = false;
    private readonly promptReferenceStorageKey = 'ptsd.referencePromptContext.v1';

    public readonly mediaTypes: any[] = [
        { value: 'image', label: '이미지', icon: 'fa-solid fa-image' },
        { value: 'audio', label: '오디오', icon: 'fa-solid fa-wave-square' },
        { value: 'video', label: '영상', icon: 'fa-solid fa-film' }
    ];
    public readonly intensityLevels: any[] = [
        { value: '1', label: '1 · 매우 낮음' },
        { value: '2', label: '2 · 낮음' },
        { value: '3', label: '3 · 중간' },
        { value: '4', label: '4 · 높음' },
        { value: '5', label: '5 · 매우 높음' }
    ];
    public readonly localeFields: any[] = [
        { key: 'era', label: '시대 규칙', icon: 'fa-solid fa-clock-rotate-left' },
        { key: 'region', label: '지역 규칙', icon: 'fa-solid fa-location-dot' },
        { key: 'guardrail', label: '시대착오 방지', icon: 'fa-solid fa-shield-halved' }
    ];
    public readonly consistencyFields: any[] = [
        { key: 'people', label: '인물', icon: 'fa-solid fa-user' },
        { key: 'background', label: '배경·장소', icon: 'fa-solid fa-mountain-city' },
        { key: 'vehicles', label: '차량·소품', icon: 'fa-solid fa-car-side' },
        { key: 'weather', label: '날씨', icon: 'fa-solid fa-cloud-sun' },
        { key: 'lighting', label: '조명', icon: 'fa-solid fa-lightbulb' },
        { key: 'audio', label: '음향 공간감', icon: 'fa-solid fa-volume-high' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.loadReferenceContext();
        await this.load();
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    private emptyForm() {
        return {
            set_key: '',
            name: '',
            scenario_label: '',
            publish_now: false,
            change_summary: '',
            source: {},
            reference_contexts: [],
            media: {
                image: {
                    target_model: 'gpt-image-2',
                    positive_prompt: '{scenario_label}의 임상적으로 중립적인 치료적 노출 이미지를 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 강도를 적용합니다.',
                    negative_prompt: '식별 가능한 얼굴, 개인정보, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
                },
                audio: {
                    target_model: 'clinical-soundscape-v1',
                    positive_prompt: '{scenario_label}의 임상적으로 중립적인 비언어 사운드스케이프를 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 강도를 적용합니다.',
                    negative_prompt: '식별 가능한 목소리, 음성으로 말한 이름, 개인정보, 비명, 그래픽한 부상 설명'
                },
                video: {
                    target_model: 'wan-2.2',
                    positive_prompt: '{scenario_label}의 짧고 임상적으로 중립적인 치료 영상을 생성합니다. 5단계 중 {intensity}단계({intensity_label})의 강도를 적용합니다.',
                    negative_prompt: '정체성 변화, 불안정한 구조, 읽을 수 있는 문자, 로고, 그래픽한 부상, 피, 고어'
                }
            },
            intensity_rules: {
                '1': '환자 승인 프롬프트 {patient_prompt}에서 사건 유형·장소·시간대 등 넓은 배경 맥락만 사용하고, 개인 고유의 핵심 촉발 단서·정확한 위치 관계·행동 시점은 생략합니다.',
                '2': '{patient_prompt}의 배경 맥락에 임상 승인된 낮은 자극 단서 1~2개만 추가하고, 핵심 사건의 정확한 진행과 위치 관계는 일반화합니다.',
                '3': '{patient_prompt}의 핵심 촉발 단서와 주요 환경을 반영하고, 승인된 위치·행동 관계 일부를 분명히 제시합니다.',
                '4': '{patient_prompt}에서 선택한 미디어로 표현 가능한 구체 단서 대부분(물체·상대 위치·행동 시점·환경 조건)을 반영하되 미승인 세부사항은 추가하지 않습니다.',
                '5': '{patient_prompt}의 임상 승인된 미디어 표현 가능 세부사항을 최대한 충실히 반영하여 물체·상대 위치·행동 시점·환경 조건이 환자 진술과 일치하도록 생성합니다.'
            },
            locale_rules: {
                era: '선택한 한국 시대의 건축·도로·교통수단·생활 도구를 교차 확인합니다.',
                region: '선택한 지역의 지형·도시 구조·기후 단서를 과장 없이 반영합니다.',
                guardrail: '현대 표지판, 상표, 번호판, 식별 문구와 시대착오 요소를 제외합니다.'
            },
            consistency_rules: {
                people: '인물의 연령대·복장·위치·시선 방향을 장면 간 일관되게 유지합니다.',
                background: '장소의 구조, 동선, 주요 배경물의 상대 위치를 고정합니다.',
                vehicles: '차종·색상·진행 방향·손상 유무를 자산 간 일치시킵니다.',
                weather: '날씨·노면 상태·시간대를 이미지, 영상, 음향에 동일하게 적용합니다.',
                lighting: '광원 방향·색온도·노출 수준을 모든 시각 자산에 맞춥니다.',
                audio: '공간 크기·재질·거리감에 맞는 환경음과 잔향을 유지합니다.'
            }
        };
    }

    public async load(preferredKey: string = '', preferredVersion: number = 0) {
        const resumePendingDraft = this.isNew && !!this.pendingDraft && !preferredKey;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('bootstrap', {});
            if (code !== 200) {
                this.errorMessage = data?.message || '프롬프트 세트를 불러오지 못했습니다.';
                return;
            }
            this.sets = Array.isArray(data?.sets) ? data.sets : [];
            this.summary = data?.summary || this.summary;
            this.canManage = data?.can_manage === true;
            const key = preferredKey || this.selectedKey;
            const version = Number(preferredVersion || this.selectedVersion || 0);
            const preferred = this.sets.find((item: any) =>
                item.scenario_type === key && (!version || Number(item.version) === version)
            );
            const fallback = this.themeCards()[0] || null;
            if (resumePendingDraft) {
                this.selectDraft(false);
            } else if (preferred || fallback) {
                this.selectSet(preferred || fallback, false);
            } else if (this.canManage) {
                this.newSet(false);
            }
        } catch (_error) {
            this.errorMessage = '프롬프트 세트를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public themeCards() {
        const latest = new Map<string, any>();
        for (const item of this.sets) {
            const key = String(item?.scenario_type || '');
            const current = latest.get(key);
            if (!current || Number(item?.version || 0) > Number(current?.version || 0)) {
                latest.set(key, item);
            }
        }
        return Array.from(latest.values()).sort((a: any, b: any) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), 'ko')
        );
    }

    public hasSearchFilters() {
        return !!(
            String(this.searchText || '').trim()
            || this.searchStatus
            || this.searchMediaType
            || this.searchModel
        );
    }

    private searchableMedia(item: any) {
        const media = item?.media || {};
        if (this.searchMediaType) {
            return [media[this.searchMediaType]].filter(Boolean);
        }
        return Object.values(media || {});
    }

    public filteredPromptSets() {
        const keyword = String(this.searchText || '').trim().toLowerCase();
        const candidates = this.hasSearchFilters() ? this.sets : this.themeCards();
        return candidates.filter((item: any) => {
            if (this.searchStatus && String(item?.status || '') !== this.searchStatus) {
                return false;
            }
            const media = this.searchableMedia(item);
            if (this.searchMediaType && media.length === 0) return false;
            if (
                this.searchModel
                && !media.some((value: any) =>
                    String(value?.target_model || '') === this.searchModel
                )
            ) {
                return false;
            }
            if (!keyword) return true;
            const rules = [
                ...Object.values(item?.intensity_rules || {}),
                ...Object.values(item?.locale_rules || {}),
                ...Object.values(item?.consistency_rules || {})
            ];
            const values = [
                item?.name,
                item?.scenario_type,
                item?.scenario_label,
                item?.change_summary,
                item?.created_by_name,
                ...media.flatMap((value: any) => [
                    value?.positive_prompt,
                    value?.negative_prompt,
                    value?.target_model
                ]),
                ...rules
            ];
            return values.some((value: any) =>
                String(value || '').toLowerCase().includes(keyword)
            );
        }).sort((a: any, b: any) => {
            const byName = String(a?.name || '').localeCompare(
                String(b?.name || ''),
                'ko'
            );
            return byName || Number(b?.version || 0) - Number(a?.version || 0);
        });
    }

    public filteredThemes() {
        return this.filteredPromptSets();
    }

    public modelFilterOptions() {
        const models = new Set<string>();
        for (const item of this.sets) {
            for (const value of Object.values(item?.media || {}) as any[]) {
                const model = String(value?.target_model || '').trim();
                if (model) models.add(model);
            }
        }
        return Array.from(models).sort((a: string, b: string) => a.localeCompare(b));
    }

    public async clearSearch() {
        this.searchText = '';
        this.searchStatus = '';
        this.searchMediaType = '';
        this.searchModel = '';
        await this.service.render();
    }

    public versionsForSelected() {
        return this.sets
            .filter((item: any) => item.scenario_type === this.selectedKey)
            .sort((a: any, b: any) => Number(b.version || 0) - Number(a.version || 0));
    }

    public currentSet() {
        return this.sets.find((item: any) =>
            item.scenario_type === this.selectedKey
            && Number(item.version || 0) === Number(this.selectedVersion || 0)
        ) || null;
    }

    private stashCurrentDraft() {
        if (!this.isNew) return;
        const previous = this.pendingDraft || {};
        this.pendingDraft = {
            ...previous,
            form: this.form,
            cloneSource: this.cloneSource,
            activeMedia: this.activeMedia
        };
    }

    private activateDraft(
        form: any,
        cloneSource: any = null,
        render: boolean = true,
        returnSelection: any = null
    ) {
        this.isNew = true;
        this.selectedKey = '';
        this.selectedVersion = 0;
        this.activeMedia = 'image';
        this.cloneSource = cloneSource;
        this.form = form;
        this.pendingDraft = {
            form: this.form,
            cloneSource: this.cloneSource,
            activeMedia: this.activeMedia,
            returnKey: String(returnSelection?.scenario_type || ''),
            returnVersion: Number(returnSelection?.version || 0)
        };
        if (render) {
            void this.service.render();
            setTimeout(() => document.getElementById('prompt-set-name')?.focus(), 0);
        }
    }

    public pendingDraftName() {
        return String(this.pendingDraft?.form?.name || '').trim()
            || (this.pendingDraft?.cloneSource ? '복제 프롬프트 세트' : '이름 없는 새 프롬프트');
    }

    public selectDraft(render: boolean = true) {
        if (!this.pendingDraft) return;
        this.isNew = true;
        this.selectedKey = '';
        this.selectedVersion = 0;
        this.form = this.pendingDraft.form;
        this.cloneSource = this.pendingDraft.cloneSource || null;
        this.activeMedia = this.pendingDraft.activeMedia || 'image';
        if (render) {
            void this.service.render();
            setTimeout(() => document.getElementById('prompt-set-name')?.focus(), 0);
        }
    }

    public selectSet(item: any, render: boolean = true) {
        if (!item) return;
        this.stashCurrentDraft();
        this.isNew = false;
        this.selectedKey = String(item.scenario_type || '');
        this.selectedVersion = Number(item.version || 0);
        this.activeMedia = 'image';
        this.cloneSource = null;
        const defaults = this.emptyForm();
        const media: any = {};
        for (const definition of this.mediaTypes) {
            const value = item?.media?.[definition.value] || {};
            media[definition.value] = {
                target_model: value.target_model || defaults.media[definition.value].target_model,
                positive_prompt: value.positive_prompt || defaults.media[definition.value].positive_prompt,
                negative_prompt: value.negative_prompt || defaults.media[definition.value].negative_prompt
            };
        }
        this.form = {
            set_key: item.scenario_type || '',
            name: item.name || '',
            scenario_label: item.scenario_label || '',
            publish_now: false,
            change_summary: '',
            source: {
                scenario_type: item.scenario_type || '',
                version: Number(item.version || 0)
            },
            reference_contexts: Array.isArray(item.reference_contexts)
                ? item.reference_contexts.map((context: any) => ({ ...context }))
                : [],
            media,
            intensity_rules: { ...defaults.intensity_rules, ...(item.intensity_rules || {}) },
            locale_rules: { ...defaults.locale_rules, ...(item.locale_rules || {}) },
            consistency_rules: { ...defaults.consistency_rules, ...(item.consistency_rules || {}) }
        };
        if (this.pendingDraft) {
            this.pendingDraft.returnKey = this.selectedKey;
            this.pendingDraft.returnVersion = this.selectedVersion;
        }
        if (render) void this.service.render();
    }

    public selectVersion(item: any) {
        this.selectSet(item);
    }

    public newSet(render: boolean = true) {
        if (!this.canManage) return;
        if (this.pendingDraft) {
            this.selectDraft(render);
            return;
        }
        const returnSelection = this.currentSet();
        const form = this.emptyForm();
        form.change_summary = '새 프롬프트 세트 초안 생성';
        this.activateDraft(form, null, render, returnSelection);
    }

    public async cloneSet(item: any = this.currentSet()) {
        if (!this.canManage || !item) return;
        if (this.pendingDraft) {
            const confirmed = await this.service.modal.show({
                title: '작성 중인 세트 바꾸기',
                message: '현재 작성 중인 새 프롬프트를 버리고 선택한 세트의 복제본으로 바꿉니다.',
                action: '복제본으로 바꾸기',
                actionBtn: 'warning',
                status: 'warning'
            });
            if (!confirmed) return;
        }
        const source = {
            scenario_type: String(item.scenario_type || ''),
            version: Number(item.version || 0),
            name: String(item.name || '')
        };
        this.selectSet(item, false);
        this.form.set_key = '';
        this.form.name = `${source.name} 복사본`.slice(0, 120);
        this.form.publish_now = false;
        this.form.change_summary = `${source.name} v${source.version}에서 복제`.slice(0, 255);
        this.form.source = {
            scenario_type: source.scenario_type,
            version: source.version
        };
        this.activateDraft(this.form, source, true, item);
    }

    public async discardDraft(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.pendingDraft) return;
        const confirmed = await this.service.modal.show({
            title: '작성 중인 세트 취소',
            message: '아직 저장하지 않은 새 프롬프트 세트를 삭제합니다.',
            action: '작성 취소',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        const wasSelected = this.isNew;
        const returnKey = String(this.pendingDraft.returnKey || '');
        const returnVersion = Number(this.pendingDraft.returnVersion || 0);
        this.pendingDraft = null;
        if (wasSelected) {
            this.isNew = false;
            const returnSet = this.sets.find((item: any) =>
                item.scenario_type === returnKey
                && Number(item.version || 0) === returnVersion
            ) || this.themeCards()[0] || null;
            if (returnSet) {
                this.selectSet(returnSet, false);
            } else {
                this.selectedKey = '';
                this.selectedVersion = 0;
                this.cloneSource = null;
                this.form = this.emptyForm();
            }
        }
        await this.service.render();
    }

    public selectMedia(mediaType: 'image' | 'audio' | 'video') {
        this.activeMedia = mediaType;
        if (this.isNew && this.pendingDraft) {
            this.pendingDraft.activeMedia = mediaType;
        }
        void this.service.render();
    }

    private cleanReferenceValue(value: any, maximum: number = 120) {
        return String(value || '')
            .replace(/[\u0000-\u001f\u007f]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, maximum);
    }

    private loadReferenceContext() {
        let parsed: any = null;
        try {
            parsed = JSON.parse(
                window.sessionStorage.getItem(this.promptReferenceStorageKey) || 'null'
            );
        } catch (_error) {
            parsed = null;
        }
        if (!parsed || Number(parsed?.schema_version || 0) !== 1) return;
        this.referenceContext = {
            reference_id: this.cleanReferenceValue(parsed.reference_id, 64),
            title: this.cleanReferenceValue(parsed.title, 255),
            source_label: this.cleanReferenceValue(parsed.source_label),
            source_url: this.cleanReferenceUrl(parsed.source_url),
            source_credit: this.cleanReferenceValue(parsed.source_credit, 255),
            era_label: this.cleanReferenceValue(parsed.era_label, 80),
            region: this.cleanReferenceValue(parsed.region, 80),
            district: this.cleanReferenceValue(parsed.district, 80),
            category: this.cleanReferenceValue(parsed.category)
        };
    }

    public referenceContextSummary() {
        return this.referenceSummary(this.referenceContext);
    }

    public referenceSummary(context: any) {
        if (!context) return '';
        const values = [
            context.era_label,
            context.region,
            context.district,
            context.category
        ].filter((value: string, index: number, items: string[]) =>
            !!value && value !== '연대 미상' && items.indexOf(value) === index
        );
        return values.join(' · ') || '분류된 시대·지역 정보가 없습니다.';
    }

    private cleanReferenceUrl(value: any) {
        const text = this.cleanReferenceValue(value, 1000);
        return /^https?:\/\//i.test(text) ? text : '';
    }

    private appendRule(current: any, addition: string, maximum: number = 500) {
        const original = String(current || '').trim();
        if (!addition || original.includes(addition)) return original;
        return [original, addition].filter(Boolean).join('\n').slice(0, maximum);
    }

    public async applyReferenceContext() {
        if (!this.canManage || !this.referenceContext || this.referenceContextApplied) return;
        const era = this.referenceContext.era_label && this.referenceContext.era_label !== '연대 미상'
            ? `레퍼런스 메타데이터 기준 촬영·생산 시대는 ${this.referenceContext.era_label}입니다. 해당 시대의 일반적인 건축·교통·생활 도구 특징만 반영합니다.`
            : '';
        const place = [
            this.referenceContext.region,
            this.referenceContext.district,
            this.referenceContext.category
        ].filter(Boolean).join(' · ');
        const region = place
            ? `레퍼런스 메타데이터 기준 지역·분류는 ${place}입니다. 해당 지역의 일반적인 지형·도시 구조·기후 단서만 반영합니다.`
            : '';
        const guardrail = '원본 이미지 파일은 생성 모델에 전달하지 않으며 특정 구도·인물·문구·고유 표현을 재현하지 않습니다.';
        this.form.locale_rules.era = this.appendRule(this.form.locale_rules.era, era);
        this.form.locale_rules.region = this.appendRule(this.form.locale_rules.region, region);
        this.form.locale_rules.guardrail = this.appendRule(
            this.form.locale_rules.guardrail,
            guardrail
        );
        const contexts = Array.isArray(this.form.reference_contexts)
            ? this.form.reference_contexts
            : [];
        const duplicate = contexts.some((context: any) =>
            String(context?.reference_id || '') === String(this.referenceContext.reference_id || '')
            && String(context?.source_url || '') === String(this.referenceContext.source_url || '')
        );
        if (!duplicate) {
            this.form.reference_contexts = [...contexts, { ...this.referenceContext }];
        }
        const source = this.referenceContext.source_label || '공공 아카이브';
        this.form.change_summary = `레퍼런스 메타데이터 반영: ${source}`.slice(0, 255);
        this.referenceContextApplied = true;
        try {
            window.sessionStorage.removeItem(this.promptReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    public async dismissReferenceContext() {
        this.referenceContext = null;
        this.referenceContextApplied = false;
        try {
            window.sessionStorage.removeItem(this.promptReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    public modelOptions(mediaType: string) {
        if (mediaType === 'image') {
            return [
                { value: 'gpt-image-2', label: 'OpenAI · GPT Image 2' },
                { value: 'kling-v2-1-image', label: 'Kling · Image 2.1' },
                { value: 'seedream-4.0', label: 'EvoLink · Seedream 4.0' }
            ];
        }
        if (mediaType === 'video') {
            return [
                { value: 'kling-v3', label: 'Kling · Video 3.0' },
                { value: 'seedance-2.5', label: 'EvoLink · Seedance 2.5' },
                { value: 'wan-2.2', label: 'ComfyUI · Wan 2.2' }
            ];
        }
        return [
            { value: 'clinical-soundscape-v1', label: 'Clinical Soundscape v1' },
            { value: 'openai-gpt-audio', label: 'OpenAI · GPT Audio' }
        ];
    }

    public mediaLabel(mediaType: string) {
        return this.mediaTypes.find((item: any) => item.value === mediaType)?.label || mediaType;
    }

    public mediaIcon(mediaType: string) {
        return this.mediaTypes.find((item: any) => item.value === mediaType)?.icon || 'fa-solid fa-file';
    }

    public statusLabel(status: string) {
        const labels: any = {
            active: '활성',
            draft: '초안',
            archived: '보관',
            queued: '대기',
            running: '생성 중',
            postprocessing: '후처리',
            review_pending: '검수 대기',
            approved: '승인',
            rejected: '반려',
            failed: '실패',
            cancelled: '취소',
            quarantined: '격리'
        };
        return labels[status] || status || '-';
    }

    public resultStatusClass(status: string) {
        if (status === 'approved') return 'bg-emerald-50 text-emerald-700';
        if (status === 'failed' || status === 'rejected') return 'bg-rose-50 text-rose-700';
        if (status === 'running' || status === 'postprocessing') return 'bg-blue-50 text-blue-700';
        if (status === 'review_pending') return 'bg-amber-50 text-amber-700';
        return 'bg-slate-100 text-slate-600';
    }

    public lineageLabel(item: any) {
        if (!item?.source) return '최초 생성';
        const action = item?.lineage_action === 'cloned' ? '복제' : '수정';
        return `${item.source.name || item.source.scenario_type} v${item.source.version}에서 ${action}`;
    }

    public resultParameterSummary(result: any) {
        const parameters = result?.parameters || {};
        const values: string[] = [];
        if (parameters.intensity) values.push(`강도 ${parameters.intensity}`);
        if (parameters.candidate_count) {
            const position = parameters.candidate_index
                ? ` ${parameters.candidate_index}/${parameters.candidate_count}`
                : ` ${parameters.candidate_count}개`;
            values.push(`후보${position}`);
        }
        if (parameters.video_duration_seconds) {
            values.push(`${parameters.video_duration_seconds}초`);
        }
        for (const key of ['resolution', 'aspect_ratio', 'quality', 'fps', 'seed']) {
            if (parameters[key] !== undefined && parameters[key] !== '') {
                values.push(`${key} ${parameters[key]}`);
            }
        }
        return values.join(' · ') || '기본 파라미터';
    }

    public date(value: any) {
        const text = String(value || '');
        if (!text) return '-';
        return text.replace('T', ' ').slice(0, 16);
    }

    public async save() {
        if (!this.canManage || this.saving || this.publishing || this.deleting) return;
        if (!String(this.form.name || '').trim() || !String(this.form.set_key || '').trim()) {
            await this.service.modal.error('세트 이름과 세트 키를 입력해주세요.');
            return;
        }
        if (!String(this.form.change_summary || '').trim()) {
            await this.service.modal.error('이번 버전의 변경 내용을 입력해주세요.');
            return;
        }
        const targetKey = String(this.form.set_key || '').trim().toLowerCase();
        const targetVersions = this.sets.filter((item: any) =>
            String(item?.scenario_type || '') === targetKey
        );
        const nextVersion = targetVersions.length === 0 ? 1 : Math.max(
            0,
            ...targetVersions.map((item: any) => Number(item.version || 0))
        ) + 1;
        const confirmed = await this.service.modal.show({
            title: this.form.publish_now ? '새 버전 저장 및 활성화' : '새 버전 초안 저장',
            message: `${this.form.name} v${nextVersion}을(를) 새 버전으로 저장합니다. 한국어 원문에서 생성 모델용 영어 파생본을 자동으로 준비하며, 기존 버전과 생성 결과는 유지됩니다.`,
            action: this.form.publish_now ? '저장·활성화' : '초안 저장',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;

        const savingPendingDraft = this.isNew;
        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                ...this.form,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 201) {
                await this.service.modal.error(data?.message || '프롬프트 세트를 저장하지 못했습니다.');
                return;
            }
            if (savingPendingDraft) {
                this.pendingDraft = null;
                this.isNew = false;
                this.cloneSource = null;
            }
            await this.load(data.scenario_type, Number(data.version || 0));
        } catch (_error) {
            await this.service.modal.error('프롬프트 세트를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async reuseVersion(item: any = this.currentSet()) {
        await this.publish(item, true);
    }

    public async deleteSet(item: any = this.currentSet()) {
        if (
            !this.canManage
            || this.isNew
            || this.saving
            || this.publishing
            || this.deleting
            || !item
        ) return;

        const setKey = String(item.scenario_type || '');
        const name = String(item.name || setKey);
        const versionCount = this.sets.filter((value: any) =>
            value.scenario_type === setKey
        ).length;
        const confirmed = await this.service.modal.show({
            title: '프롬프트 세트 전체 삭제',
            message: `${name} 세트의 모든 버전 ${versionCount}개를 삭제합니다. 삭제한 세트는 복구할 수 없습니다.`,
            action: '세트 삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        this.deleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_set', {
                set_key: setKey,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '프롬프트 세트를 삭제하지 못했습니다.');
                return;
            }
            this.selectedKey = '';
            this.selectedVersion = 0;
            this.isNew = false;
            await this.load();
            await this.service.modal.success(`${name} 프롬프트 세트를 삭제했습니다.`);
        } catch (_error) {
            await this.service.modal.error('프롬프트 세트를 삭제하지 못했습니다.');
        } finally {
            this.deleting = false;
            await this.service.render();
        }
    }

    public async publish(item: any = this.currentSet(), reuse: boolean = false) {
        if (
            !this.canManage
            || this.saving
            || this.publishing
            || this.deleting
            || !item
            || item.is_active
        ) return;
        const confirmed = await this.service.modal.show({
            title: reuse ? '프롬프트 버전 재사용' : '프롬프트 버전 활성화',
            message: `${item.name} v${item.version}을(를) 콘텐츠 생성에 사용합니다. 현재 활성 버전은 보관됩니다.`,
            action: reuse ? '재사용' : '활성화',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;
        this.publishing = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('publish', {
                set_key: item.scenario_type,
                version: item.version,
                reuse,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '프롬프트 버전을 활성화하지 못했습니다.');
                return;
            }
            await this.load(item.scenario_type, Number(item.version || 0));
        } catch (_error) {
            await this.service.modal.error('프롬프트 버전을 활성화하지 못했습니다.');
        } finally {
            this.publishing = false;
            await this.service.render();
        }
    }
}

export default PagePromptsComponent;